var sortOptionToOptionType = function sortOptionToOptionType(option) {
  return option ? {
    title: option.title,
    value: option.key
  } : {};
};

export default sortOptionToOptionType;